/**
 * 🏢 Frontend SaaS Work Week & Weekly Off Policy Engine
 */

export const POLICY_TYPES = {
  SUNDAY_ONLY: 'SUNDAY_ONLY',
  LAST_SATURDAY_OFF: 'LAST_SATURDAY_OFF',
  ALTERNATE_2_4_SATURDAY: 'ALTERNATE_2_4_SATURDAY',
  ALL_SATURDAY_OFF: 'ALL_SATURDAY_OFF',
  FIRST_THIRD_SATURDAY: 'FIRST_THIRD_SATURDAY'
};

export const POLICY_OPTIONS = [
  {
    key: 'LAST_SATURDAY_OFF',
    label: 'Last Saturday of Month Off + Every Sunday',
    description: 'Standard office rule: Only the final Saturday of each month is a paid holiday.'
  },
  {
    key: 'SUNDAY_ONLY',
    label: 'Every Sunday Only (6 Days Work Week)',
    description: 'All Saturdays are normal working days; only Sundays are off.'
  },
  {
    key: 'ALTERNATE_2_4_SATURDAY',
    label: '2nd & 4th Saturday Off (Alternate) + Every Sunday',
    description: 'Banking & corporate standard: 2nd and 4th Saturdays of every month are off.'
  },
  {
    key: 'ALL_SATURDAY_OFF',
    label: 'All Saturdays & Sundays Off (5 Days Work Week)',
    description: 'IT & MNC corporate standard: 5 working days per week.'
  },
  {
    key: 'FIRST_THIRD_SATURDAY',
    label: '1st & 3rd Saturday Off + Every Sunday',
    description: '1st and 3rd Saturdays of every month are off.'
  }
];

export function checkCompanyWeekOff(dateObjOrDay, month, year, policy = 'LAST_SATURDAY_OFF') {
  let dayNum;
  let d;

  const monthNum = typeof month === 'number'
    ? month
    : (['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].indexOf(month) + 1);

  if (dateObjOrDay instanceof Date) {
    d = dateObjOrDay;
    dayNum = d.getDate();
  } else {
    dayNum = parseInt(dateObjOrDay, 10);
    d = new Date(year, monthNum - 1, dayNum);
  }

  const dayOfWeek = d.getDay(); // 0 = Sunday, 6 = Saturday

  // 1. Sunday is always a weekly off
  if (dayOfWeek === 0) {
    return { isOff: true, type: 'sunday', label: 'Sunday' };
  }

  // 2. Mon-Fri are regular workdays
  if (dayOfWeek !== 6) {
    return { isOff: false, type: 'workday', label: 'Workday' };
  }

  // 3. Saturday Policy Check
  const totalDaysInMonth = new Date(year, monthNum, 0).getDate();

  if (policy === POLICY_TYPES.ALL_SATURDAY_OFF) {
    return { isOff: true, type: 'saturday', label: 'Saturday Off' };
  }

  if (policy === POLICY_TYPES.SUNDAY_ONLY) {
    return { isOff: false, type: 'workday', label: 'Working Saturday' };
  }

  if (policy === POLICY_TYPES.LAST_SATURDAY_OFF) {
    if (dayNum + 7 > totalDaysInMonth) {
      return { isOff: true, type: 'last_saturday', label: 'Last Sat Off' };
    }
    return { isOff: false, type: 'workday', label: 'Working Saturday' };
  }

  const satIndex = Math.ceil(dayNum / 7);

  if (policy === POLICY_TYPES.ALTERNATE_2_4_SATURDAY) {
    if (satIndex === 2 || satIndex === 4) {
      return { isOff: true, type: 'alternate_saturday', label: `${satIndex === 2 ? '2nd' : '4th'} Sat Off` };
    }
    return { isOff: false, type: 'workday', label: 'Working Saturday' };
  }

  if (policy === POLICY_TYPES.FIRST_THIRD_SATURDAY) {
    if (satIndex === 1 || satIndex === 3) {
      return { isOff: true, type: 'alternate_saturday', label: `${satIndex === 1 ? '1st' : '3rd'} Sat Off` };
    }
    return { isOff: false, type: 'workday', label: 'Working Saturday' };
  }

  return { isOff: false, type: 'workday', label: 'Workday' };
}

export function calculateWorkingDays(month, year, policy = 'LAST_SATURDAY_OFF', holidayCount = 0) {
  const monthNum = typeof month === 'number'
    ? month
    : (['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].indexOf(month) + 1);

  const totalDays = new Date(year, monthNum, 0).getDate();
  let weekOffCount = 0;

  for (let day = 1; day <= totalDays; day++) {
    const status = checkCompanyWeekOff(day, monthNum, year, policy);
    if (status.isOff) {
      weekOffCount++;
    }
  }

  return Math.max(1, totalDays - weekOffCount - holidayCount);
}
